import { deriveStockStatus } from "./inventoryHelpers";

export function searchFilterStock(items, searchTerm, categoryFilter = "All", statusFilter = "All") {
  if (!Array.isArray(items) || items.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return items.filter((item) => {
    const matchesSearch =
      !term ||
      item.productName?.toLowerCase().includes(term) ||
      item.sku?.toLowerCase().includes(term) ||
      item.category?.toLowerCase().includes(term);

    const matchesCategory = categoryFilter === "All" || item.category === categoryFilter;

    const matchesStatus =
      statusFilter === "All" || deriveStockStatus(item) === statusFilter.toLowerCase();

    return matchesSearch && matchesCategory && matchesStatus;
  });
}
